'use client'
import * as React from 'react'
import dynamic from 'next/dynamic'
import { useTranslations } from 'next-intl'
import { useUserQuery } from 'auth/hooks'
import { isLoggedInQuerySelector } from 'auth/selectors'
import { keepPreviousData } from '@tanstack/react-query'

import { ReturnIcon } from '../../icons/return'
import { ModalForm } from './modal-form'

/**
 * We are using dynamic import to load the modal component only when the user clicks on the report button.
 * It creates a separate chunk for the modal component and loads it only when required.
 */
const ModalWithError = dynamic(
  () => import('../modal-with-error').then(module => module.ModalWithError),
  {
    ssr: false,
    loading: () => null,
  },
)

export function ReplyButton() {
  const t = useTranslations('prod.product_description_page.reviews')
  const { data: isAuthenticated } = useUserQuery(undefined, {
    placeholderData: keepPreviousData,
    select: isLoggedInQuerySelector,
  })
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  if (!isAuthenticated) {
    return null
  }

  return (
    <>
      <button
        className="text-cf-link items-centers my-4 flex items-center gap-1"
        onClick={() => {
          setIsModalOpen(true)
        }}
      >
        <ReturnIcon className="text-cf-dreamy-cloud-900" />
        {t('reply')}
      </button>
      {isModalOpen ? (
        <ModalWithError
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false)
          }}
          error={error}
        >
          <ModalForm
            onClose={() => {
              setIsModalOpen(false)
            }}
            setError={setError}
          />
        </ModalWithError>
      ) : null}
    </>
  )
}
